<div class="lm-flex-row-responsive-container">
    <ng-container [ngTemplateOutlet]="SOURCE"></ng-container>
    <ng-container [ngTemplateOutlet]="DATA_OPTIONS"></ng-container>
    <ng-container *ngIf="model.dataOption === 'live' ||  model.dataOption === 'archive'" [ngTemplateOutlet]="AS_OF_DATE"></ng-container>
</div>

<ng-template #SOURCE>
    <div class="lm-report-widget">
        <h2 class="fieldset-title">{{ 'ListPersonalizationSource' | translate }}</h2>
        <div class="field">
            <label soho-label for="businessClass">{{ 'CreateReportBusinessClassLabel' | translate }}</label>
            <p
                    id="businessClass"
                    class="hide-white-space lm-text-data text-default"
                    data-automation-id="lm-personalization-business-class"
            >{{model.businessClass}}</p>
        </div>
        <div class="field">
            <label soho-label for="listName">{{ 'CreateReportListLabel' | translate }}</label>
            <p
                    id="listName"
                    class="hide-white-space lm-text-data text-default"
                    data-automation-id="lm-personalization-list-name"
            >{{model.listName}}</p>
        </div>
    </div>
</ng-template>
<ng-template #DATA_OPTIONS>
    <div class="lm-report-widget">
        <h2 class="fieldset-title">{{ 'ListPersonalizationDataSourceTab' | translate }}</h2>
        <ng-container *ngIf="!readonlyDataSource">
            <div class="field">
                <input
                        data-automation-id="lm-personalization-live-data-source"
                        soho-radiobutton
                        type="radio"
                        soho-trackdirty
                        name="optionsGroupData"
                        id="optionsGroupDataLive"
                        value="live"
                        [disabled]="!model.isReport"
                        [(ngModel)]="model.dataOption"
                        (change)="onDataOptionChanged()"/>
                <label soho-label [forRadioButton]="true" for="optionsGroupDataLive">{{ 'ListPersonalizationSourceTransaction' | translate }}</label>
                <br>
                <input
                        data-automation-id="lm-personalization-audit-data-source"
                        soho-radiobutton
                        type="radio"
                        soho-trackdirty
                        name="optionsGroupData"
                        id="optionsGroupDataAudit"
                        value="audit"
                        [disabled]="!model.isReport || !model.implementsAuditing"
                        [(ngModel)]="model.dataOption"
                        (change)="onDataOptionChanged()"/>
                <label soho-label [forRadioButton]="true" for="optionsGroupDataAudit">{{ 'ListPersonalizationSourceTransactionAudit' | translate }}</label>
                <br>
                <input
                        data-automation-id="lm-personalization-archive-data-source"
                        soho-radiobutton
                        type="radio"
                        soho-trackdirty
                        name="optionsGroupData"
                        id="optionsGroupDataArchive"
                        value="archive"
                        [disabled]="!(archiveFeatureEnabled && model.isReport && model.implementsArchivable)"
                        [(ngModel)]="model.dataOption"
                        (change)="onDataOptionChanged()"/>
                <label soho-label [forRadioButton]="true" for="optionsGroupDataArchive">{{ 'ListPersonalizationSourceArchive' | translate }}</label>
                <br>
                <input
                        data-automation-id="lm-personalization-audit-archive-data-source"
                        soho-radiobutton
                        type="radio"
                        soho-trackdirty
                        name="optionsGroupData"
                        id="optionsGroupDataAuditArchive"
                        value="archiveAudit"
                        [disabled]="!(archiveFeatureEnabled && model.isReport && model.implementsAuditing && model.implementsArchivable)"
                        [(ngModel)]="model.dataOption"
                        (change)="onDataOptionChanged()"/>
                <label soho-label [forRadioButton]="true" for="optionsGroupDataAuditArchive">{{ 'ListPersonalizationSourceArchiveAudit' | translate }}</label>
            </div>
        </ng-container>
        <ng-container *ngIf="readonlyDataSource">
            <div class="field">
                <p
                   class="hide-white-space lm-text-data text-default"
                   data-automation-id="lm-personalization-data-source"
                >{{dataOptionText}}</p>
            </div>
        </ng-container>
    </div>
</ng-template>
<ng-template #AS_OF_DATE>
    <div class="lm-report-widget">
        <h2 class="fieldset-title">{{ 'CreateReportAsOfDateLabel' | translate }}</h2>
        <ng-container *ngIf="!readonlyAsOfDate">
            <div class="field">
                <!--            <label soho-label>{{ 'CreateReportAsOfDateLabel' | translate }}</label>-->
                <input
                        data-automation-id="lm-personalization-as-of-date"
                        class="input-sm"
                        soho-datepicker
                        [options]="asOfDatePickerOptions"
                        [disabled]="readonlyAsOfDate"
                        [readonly]="readonlyAsOfDate"
                        soho-trackdirty
                        [(ngModel)]="model.asOfDate"/>
            </div>
        </ng-container>
        <ng-container *ngIf="readonlyAsOfDate">
            <div class="field">
                <p
                        id="asofdate"
                        class="hide-white-space lm-text-data text-default"
                        data-automation-id="lm-personalization-as-of-date"
                >{{ asOfDateText }}</p>
            </div>
        </ng-container>
    </div>
</ng-template>